import React, { useState } from 'react'
import { Building2, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'

const WorkspaceSwitcher: React.FC<{ darkMode?: boolean; compact?: boolean }> = ({ darkMode, compact }) => {
  const { t } = useTranslation()
  const { workspaces, activeCustomerId, isPlatformAdmin, switchWorkspace } = useAuth()
  const [switching, setSwitching] = useState(false)
  const [error, setError] = useState('')

  if (workspaces.length <= 1 && !isPlatformAdmin) return null

  const changeWorkspace = async (value: string) => {
    setSwitching(true)
    setError('')
    const customerId = value === 'platform' ? null : Number(value)
    const result = await switchWorkspace(customerId)
    if (result.status === 'authenticated') {
      window.location.reload()
      return
    }
    setError(result.status === 'error' ? result.error : t('workspace_switch_failed'))
    setSwitching(false)
  }

  return (
    <div className="relative" title={error || t('workspace_switcher')}>
      <Building2 size={14} className={`pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} />
      <select value={activeCustomerId == null ? 'platform' : String(activeCustomerId)}
        onChange={event => changeWorkspace(event.target.value)} disabled={switching}
        aria-label={t('workspace_switcher')}
        className={`max-w-[190px] rounded-lg border py-2 pl-7 pr-7 text-xs outline-none disabled:opacity-60 ${
          darkMode ? 'border-gray-700 bg-gray-800 text-gray-200' : 'border-gray-200 bg-white text-gray-700'
        } ${compact ? 'max-w-[145px]' : ''}`}>
        {isPlatformAdmin && <option value="platform">{t('workspace_platform')}</option>}
        {workspaces.map(workspace => (
          <option key={workspace.customerId} value={workspace.customerId}>{workspace.customerName}</option>
        ))}
      </select>
      {switching && <Loader2 size={13} className="absolute right-2 top-1/2 -translate-y-1/2 animate-spin text-blue-500" />}
    </div>
  )
}

export default WorkspaceSwitcher
